import { Component, OnInit, Renderer2, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'guidance',
  templateUrl: './guidance.component.html',
  styleUrls: ['./guidance.component.scss'],
})
export class GuidanceComponent implements OnInit {
public companyName = '';
public companyName1 ='の皆様';
public fee1;
public multifee1;
public promotion;
public fee2;
public multifee2;
public entryfee;
public cnt = 100;
public guideText = 'ご登録に必要なもの';
public guideText1 = '●JOYFIT 法人会員証明書　●ご本人確認書類（健康保険証）●キャッシュカード';
public guideText2 = '※JOYFIT法人会員証明書は、従業員個人様の情報記入と会社・組合認印が必要です。※証明書は会社・組合より発行されます。';

public guideText3 = '●JOYFIT App（お手持ちのスマホから）​';
public guideText4 = '●健康保険証 or マイナ保険証 or 資格確認書（記号・番号の入力が必要となります）​​';
public guideText5 = '●プロモーションコード　　　　　●クレジットカード（月会費のお支払い用）​';


  constructor(
    private renderer: Renderer2,
    public translate: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
    private titleService:Title,
  ) {
    this.titleService.setTitle("JOYFIT 法人入会案内");
  }
  public logoUrl;

 slice(data){
  var list = [];
  var k = data - 1;
    for (var i = 1, j = 1; i <= this.companyName.length; i++, j++) {
      i = i + k;
      j = j + k;
      list.push(this.companyName.substring(j - data, i));
    }
  return list;
 }
  
  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (params == null || params == undefined) {
        this.router.navigate(['/company-register']);
      }
      this.companyName = params['company_name'];
      this.fee1 = params['fees1'];
      this.fee2 = params['fees2'];
      this.entryfee = params['entryfee'];
      this.promotion = params['promotion'];
    });
    if(this.companyName != undefined){
      var fontsize = 40;
      var substrings = this.slice(this.companyName.length);
      const canvas = <HTMLCanvasElement> document.getElementById("canvas");
      const ctx = canvas.getContext("2d");
      canvas.height = 200;
      canvas.width = 1200;

      const x = canvas.width / 2;
      var y = canvas.height;
      ctx.beginPath();
      ctx.moveTo(x, 0);
      ctx.lineTo(x, canvas.height);
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = "high";
      ctx.textAlign = "center";
      if(this.companyName.length >= 30 && this.companyName.length < 35){
        fontsize =  fontsize - 5;
      } else if(this.companyName.length >= 35 && this.companyName.length < 40){
        fontsize =  fontsize - 10;
      } else if(this.companyName.length >= 40 && this.companyName.length < 45){
        fontsize =  fontsize - 15;
      } else if (this.companyName.length >= 45 && this.companyName.length < 60){
        fontsize =  fontsize - 20;
      }  else if (this.companyName.length >= 60 && this.companyName.length < 80){
        fontsize =  fontsize - 25;
      } else if (this.companyName.length >= 80){
        fontsize =  fontsize - 28;
      } 
      ctx.font =  fontsize + "px sans-serif";

      if (this.companyName.length > 95) {
        const lines: string[] = [];
        for (let i = 0; i < this.companyName.length; i += 95) {
          lines.push(this.companyName.slice(i, i + 95));
        }
      
        const offsetY = -25;
      
        lines.forEach((line, index) => {
          ctx.fillText(
            line,
            x,
            y / 2 + (index - Math.floor(lines.length / 2)) * fontsize + offsetY
          );
        });
      
      
      } else {
        var a = substrings.length;
        substrings.forEach((substrings, index) => {
          y = canvas.height;
          ctx.fillText(substrings, x, y + (index - a) * fontsize + fontsize - 120);
        });
      }
    } else {
      this.companyName = ''
    }

    if(this.fee1 == undefined){
      this.fee1 = 0;
    } 
    if(this.entryfee == undefined){
      this.entryfee = 0;
    } 
    if(this.fee1 == 0 &&  this.entryfee == 0){
      this.multifee1 = Math.floor(parseInt(this.fee1) * 1.1);
      var canvasText = 'お勤め先にお問い合わせください';
      const canvas2 = <HTMLCanvasElement> document.getElementById('canvas2');
      var ctx2 = canvas2.getContext("2d");
      canvas2.width =750;
      const x2 = canvas2.width / 2;
      ctx2.beginPath();
      ctx2.moveTo(x2, 0);
      ctx2.lineTo(x2, canvas2.height);
      ctx2.font = "20px sans-serif";
      ctx2.textAlign = "center";
      ctx2.fillText(canvasText, x2, 80);
    } else {
      this.multifee1 = Math.floor(parseInt(this.fee1) * 1.1);
      var canvasText = this.fee1 + '円（税込' + this.multifee1 + '円）～  ※別途、入会金' + this.entryfee + '円（税別）／人が必要です。'
      const canvas2 = <HTMLCanvasElement> document.getElementById('canvas2');
      var ctx2 = canvas2.getContext("2d");
      canvas2.width =750;
      const x2 = canvas2.width / 2;
      ctx2.beginPath();
      ctx2.moveTo(x2, 0);
      ctx2.lineTo(x2, canvas2.height);
      ctx2.font = "20px sans-serif";
      ctx2.textAlign = "center";
      ctx2.fillText(canvasText, x2, 80);
    }

    if(this.promotion == undefined){
      this.promotion = '';
    }

    const canvas3 = <HTMLCanvasElement> document.getElementById('canvas3');
    var ctx3 = canvas3.getContext("2d");
    canvas3.width =750;
    const x3 = canvas3.width / 2;
    ctx3.beginPath();
    ctx3.moveTo(x3, 0);
    ctx3.lineTo(x3, canvas3.height);
    ctx3.font = "70px sans-serif";
    ctx3.textAlign = "center";
    ctx3.fillText(this.promotion, x3, 80);


    const canvas4 = <HTMLCanvasElement> document.getElementById('canvas4');
    var ctx4 = canvas4.getContext("2d");
    canvas4.width = 1100;
    
    ctx4.beginPath();
    ctx4.moveTo(0, 0);
    ctx4.lineTo(0, canvas4.height);
    
    ctx4.font = "20px sans-serif";
    ctx4.textAlign = "left";
    
    const marginLeft = 0;
    
    ctx4.fillText(this.guideText3, marginLeft, 80);
    ctx4.fillText(this.guideText4, marginLeft, 110);
    ctx4.fillText(this.guideText5, marginLeft, 140);

  }
}
